import Enum from './Enum'
import * as V3Checks from 'components/v3_checks'

const CHECKS = {
  "Title": V3Checks.V3TitleCheck,
  "Meta Tags": V3Checks.V3MetaTagsCheck,
  "Filenames": V3Checks.V3FilenamesCheck,
  "Heading": V3Checks.V3HeadingCheck,
  "Images": V3Checks.V3ImagesCheck,
  "Internal Links": V3Checks.V3InternalLinksCheck,
  "Subheadings": V3Checks.V3SubheadingsCheck,
  "Blog Posts": V3Checks.V3BlogPostsCheck,
  "Blog Backlinks": V3Checks.V3BlogBacklinksCheck,
  "Exposes Syndication": V3Checks.V3ExposesSyndicationCheck,
  "Blog Posts Titles": V3Checks.V3BlogPostsTitlesCheck,
  "Blog Frequency": V3Checks.V3BlogFrequencyCheck,
  "Blog on Own Domain": V3Checks.V3BlogOnOwnDomainCheck,
  "Body Text": V3Checks.V3BodyTextCheck
}

export default class CheckUtils {
  static renderV3Check(check, props) {
    const ComponentName = CHECKS[check.get("title")]

    return <ComponentName { ...props } />
  }

  static wrapListItems(items) {
    return items
      .flat()
      .filter((item) => !!item)
      .map((item, i) => <li key={i}>{ item }</li>)
  }

  static lookupDetailsFromKey(full_key, haystack = Enum.CheckItemsDetails) {
    const [key, next_key] = full_key.split(".")

    // these may be camelCased when nested
    const real_key = key
      .replace(/([A-Z]|\d+)/g, match => `_${match.toLowerCase()}`)
      .replace(/__/, "_")

    const value = haystack[real_key]
    if (next_key) return this.lookupDetailsFromKey(next_key, value)

    return value
  }

  // Simple moustachey templater
  static template(text, template_variables) {
    let templated = text

    for (const [key, value] of Object.entries(template_variables)) {
      const regexp = new RegExp(`({{\\s*(${key})\\s*}})`, "g")
      templated = templated.replace(regexp, value)
    }

    return templated
  }

  static renderDetailsList(checkItems, dictionary = Enum.CheckItemsDetails)  {
    if (checkItems.filter((x) => x.detailsKey == "multiple_h1.multiple").length > 0) {
      console.log(dictionary)
    }
    const details = checkItems.map((checkItem) => {
      if (checkItem.detailsTemplate) {
        const templateText = this.lookupDetailsFromKey(checkItem.detailsTemplate[0], dictionary)
        return this.template(templateText, checkItem.detailsTemplate[1])
      } else if (checkItem.detailsHash) {
        const inner_details = []

        for (let prop in checkItem.detailsHash) {
          const key = this.lookupDetailsFromKey(prop, dictionary)

          inner_details.push(
            <div>
              { key }
              <ul>{ this.wrapListItems(checkItem.detailsHash[prop]) }</ul>
            </div>
          )
        }

        return inner_details
      } else if (checkItem.detailsKey) {
        const key = this.lookupDetailsFromKey(checkItem.detailsKey, dictionary)

        // Render details as nested ul if exists
        if (checkItem.details) {
          return (
            <div>
              { key }
              <ul>{this.wrapListItems(checkItem.details)}</ul>
            </div>
          )
        }

        return key
      } else if (checkItem.details) {
        return checkItem.details.map(url => <a href={url} target="_blank">{url}</a>)
      }
    })

    return <ul>{ this.wrapListItems(details) }</ul>
  }

  static friendlyTitle(title) {
    return Enum.CheckTitles[title]
  }
}



// WEBPACK FOOTER //
// ./app/utils/CheckUtils.js